import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { DateTime } from "luxon";

import { IncidentFootage } from "types/Incident";
import { IncidentViewerFootage } from "./IncidentViewerFootage";

export interface IncidentViewerFootageDialogProps {
    footage: IncidentFootage;
    onClose?: () => void;
}

export default function IncidentViewerFootageDialog(
    props: IncidentViewerFootageDialogProps,
) {
    return (
        <Dialog
            open={true}
            onClose={props.onClose}
            maxWidth={false}
        >
            <DialogTitle>
                {DateTime.fromISO(props.footage.timestamp).toLocaleString(
                    DateTime.TIME_WITH_SECONDS,
                )}{" "}
                - {props.footage.deviceName}
            </DialogTitle>
            <DialogContent>
                <IncidentViewerFootage
                    footage={props.footage}
                    showControls={true}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
